export default __webpack_public_path__ + "static/media/release5.fe684b11.jpeg";